module.exports = __webpack_public_path__ + "static/media/influence_tracks.9fad924b.png";